// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 24px;
    box-sizing: border-box;
    gap: 60px;
}

@media (max-width: 1200px) {
    .container {
        gap: 20px;
    }
}

@media (max-width: 992px) {
    .container {
        justify-content: flex-end;
        flex-direction: column-reverse;
        height: auto;
    }
}

.col {
    height: 100%;
    display: flex;
    align-items: center; /* Changed from flex-start to center */
    flex-direction: column;
    justify-content: center;
    width: 50%;
}

@media (max-width: 992px) {
    .col {
        height: auto;
        width: 100%;
        align-items: center;
    }
}

@media (min-width: 992px) {
    .hero-image {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        background: #ded8d1;
        padding: 40px;
        border-radius: 12px;
        box-sizing: border-box;
    }    
}

.hero-image img {
    max-width: 800px;    
    width: 100%;
}

@media (max-width: 992px) {
    .hero-image img {
        max-width: 400px;  
    }
}

@media (max-width: 768px) {
    .hero-image img {
        max-width: 300px;  
    }
}

.content-wrapper {
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: "Gabarito", serif;
    max-width: 600px;
}

@media (min-width: 1200px) {
    .content-wrapper {
        width: calc(1200px / 2);
    }
}

@media (max-width: 992px) {
    .content-wrapper {
        width: 100%;
        align-items: center;
    }
}

.content-wrapper h1, 
.content-wrapper p {
    font-family: "Gabarito", serif;
}

@media (max-width: 992px) {
    .content-wrapper h1, 
    .content-wrapper p {
        text-align: center;
    }
}

.content-wrapper h1 {
    line-height: 1.3;
    font-size: 48px;
    margin: 0;
}

@media (max-width: 768px) {
    .content-wrapper h1 {
        font-size: 32px;
    }
}

.content-wrapper p {
    padding: 10px 0;
    margin-bottom: 20px;
    display: block;
}

.landing-page .navbar-logo {
    position: absolute; /* Position the logo absolutely */
    top: 24px; /* Fixed distance from top */
    left: 24px;
    margin-bottom: 0; /* Remove margin that was pushing content down */
}

.landing-page .navbar-logo--responsive {
    display: none;
}

@media (max-width: 992px) {
    .landing-page .navbar-logo {
        display: none;
    }

    .landing-page .navbar-logo--responsive {
        position: relative;
        display: block;
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    .landing-page .navbar-logo--responsive {
        font-size: 20px;
    }
}

.buttons {
    margin-bottom: auto;
    display: flex;
    gap: 16px;
}

@media (max-width: 576px) {
    .buttons {
        width: 100%;
        flex-direction: column;    
    }

    .buttons .btn.theme-button {
        width: 100% !important;
    }
}

.underlined-link {
  text-decoration: underline;
  color: inherit; /* Use the default text color */
}

.underlined-link:hover {
  text-decoration: underline;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.chester-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.navbar-logo--responsive .logo-container {
  justify-content: center;
}

/* Making the hero container (existing first section) have a fixed height */
.hero-container {
  min-height: 100vh;
}

/* Feature section styles */
.feature-section {
  padding: 80px 24px;
  background-color: #f8f8f8;
}

.feature-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-subtitle {
  max-width: 600px;
  margin: 10px auto 0;
  color: #666;
  font-size: 18px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.feature-card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.feature-card svg {
  margin-bottom: 20px;
  color: #df2d11;
}

.feature-showcase {
  padding: 80px 24px;
  background-color: white;
}

.feature-showcase.reverse {
  background-color: #f8f8f8;
}

.feature-row {
  display: flex;
  align-items: center;
  gap: 60px;
}

.feature-showcase.reverse .feature-row {
  flex-direction: row-reverse;
}

.feature-content {
  flex: 1 1;
}

.feature-image {
  flex: 1 1;
  text-align: center;
}

.feature-image img {
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.feature-list {
  padding-left: 20px;
  margin-top: 20px;
}

.feature-list li {
  margin-bottom: 10px;
  font-size: 16px;
}

.cta-section {
  padding: 80px 24px;
  background-color: #df2d11;
  color: white;
  text-align: center;
}

.cta-section h2, .cta-section p {
  color: white;
}

.theme-button--large {
  padding: 12px 36px !important;
  margin-top: 30px !important;
  font-size: 18px !important;
}

.cta-button-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}

.landing-footer {
  padding: 60px 24px;
  background-color: #333;
  color: white;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a {
  color: white;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* Responsive styles */
@media (max-width: 992px) {
  .feature-row {
    flex-direction: column;
  }
  
  .feature-showcase.reverse .feature-row {
    flex-direction: column;
  }
  
  .feature-content, .feature-image {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Landing/Landing.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,8BAA8B;QAC9B,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAE,sCAAsC;IAC3D,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB,EAAE,iCAAiC;IACrD,SAAS,EAAE,4BAA4B;IACvC,UAAU;IACV,gBAAgB,EAAE,gDAAgD;AACtE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;EACE,0BAA0B;EAC1B,cAAc,EAAE,+BAA+B;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2EAA2E;AAC3E;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    padding: 24px;\n    box-sizing: border-box;\n    gap: 60px;\n}\n\n@media (max-width: 1200px) {\n    .container {\n        gap: 20px;\n    }\n}\n\n@media (max-width: 992px) {\n    .container {\n        justify-content: flex-end;\n        flex-direction: column-reverse;\n        height: auto;\n    }\n}\n\n.col {\n    height: 100%;\n    display: flex;\n    align-items: center; /* Changed from flex-start to center */\n    flex-direction: column;\n    justify-content: center;\n    width: 50%;\n}\n\n@media (max-width: 992px) {\n    .col {\n        height: auto;\n        width: 100%;\n        align-items: center;\n    }\n}\n\n@media (min-width: 992px) {\n    .hero-image {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        width: 100%;\n        background: #ded8d1;\n        padding: 40px;\n        border-radius: 12px;\n        box-sizing: border-box;\n    }    \n}\n\n.hero-image img {\n    max-width: 800px;    \n    width: 100%;\n}\n\n@media (max-width: 992px) {\n    .hero-image img {\n        max-width: 400px;  \n    }\n}\n\n@media (max-width: 768px) {\n    .hero-image img {\n        max-width: 300px;  \n    }\n}\n\n.content-wrapper {\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-family: \"Gabarito\", serif;\n    max-width: 600px;\n}\n\n@media (min-width: 1200px) {\n    .content-wrapper {\n        width: calc(1200px / 2);\n    }\n}\n\n@media (max-width: 992px) {\n    .content-wrapper {\n        width: 100%;\n        align-items: center;\n    }\n}\n\n.content-wrapper h1, \n.content-wrapper p {\n    font-family: \"Gabarito\", serif;\n}\n\n@media (max-width: 992px) {\n    .content-wrapper h1, \n    .content-wrapper p {\n        text-align: center;\n    }\n}\n\n.content-wrapper h1 {\n    line-height: 1.3;\n    font-size: 48px;\n    margin: 0;\n}\n\n@media (max-width: 768px) {\n    .content-wrapper h1 {\n        font-size: 32px;\n    }\n}\n\n.content-wrapper p {\n    padding: 10px 0;\n    margin-bottom: 20px;\n    display: block;\n}\n\n.landing-page .navbar-logo {\n    position: absolute; /* Position the logo absolutely */\n    top: 24px; /* Fixed distance from top */\n    left: 24px;\n    margin-bottom: 0; /* Remove margin that was pushing content down */\n}\n\n.landing-page .navbar-logo--responsive {\n    display: none;\n}\n\n@media (max-width: 992px) {\n    .landing-page .navbar-logo {\n        display: none;\n    }\n\n    .landing-page .navbar-logo--responsive {\n        position: relative;\n        display: block;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .landing-page .navbar-logo--responsive {\n        font-size: 20px;\n    }\n}\n\n.buttons {\n    margin-bottom: auto;\n    display: flex;\n    gap: 16px;\n}\n\n@media (max-width: 576px) {\n    .buttons {\n        width: 100%;\n        flex-direction: column;    \n    }\n\n    .buttons .btn.theme-button {\n        width: 100% !important;\n    }\n}\n\n.underlined-link {\n  text-decoration: underline;\n  color: inherit; /* Use the default text color */\n}\n\n.underlined-link:hover {\n  text-decoration: underline;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.chester-icon {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n.navbar-logo--responsive .logo-container {\n  justify-content: center;\n}\n\n/* Making the hero container (existing first section) have a fixed height */\n.hero-container {\n  min-height: 100vh;\n}\n\n/* Feature section styles */\n.feature-section {\n  padding: 80px 24px;\n  background-color: #f8f8f8;\n}\n\n.feature-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.section-subtitle {\n  max-width: 600px;\n  margin: 10px auto 0;\n  color: #666;\n  font-size: 18px;\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 40px;\n}\n\n.feature-card {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\n}\n\n.feature-card svg {\n  margin-bottom: 20px;\n  color: #df2d11;\n}\n\n.feature-showcase {\n  padding: 80px 24px;\n  background-color: white;\n}\n\n.feature-showcase.reverse {\n  background-color: #f8f8f8;\n}\n\n.feature-row {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n}\n\n.feature-showcase.reverse .feature-row {\n  flex-direction: row-reverse;\n}\n\n.feature-content {\n  flex: 1;\n}\n\n.feature-image {\n  flex: 1;\n  text-align: center;\n}\n\n.feature-image img {\n  max-width: 100%;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n.feature-list {\n  padding-left: 20px;\n  margin-top: 20px;\n}\n\n.feature-list li {\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.cta-section {\n  padding: 80px 24px;\n  background-color: #df2d11;\n  color: white;\n  text-align: center;\n}\n\n.cta-section h2, .cta-section p {\n  color: white;\n}\n\n.theme-button--large {\n  padding: 12px 36px !important;\n  margin-top: 30px !important;\n  font-size: 18px !important;\n}\n\n.cta-button-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.landing-footer {\n  padding: 60px 24px;\n  background-color: #333;\n  color: white;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n}\n\n.footer-links {\n  display: flex;\n  gap: 20px;\n}\n\n.footer-links a {\n  color: white;\n  text-decoration: none;\n}\n\n.footer-links a:hover {\n  text-decoration: underline;\n}\n\n/* Responsive styles */\n@media (max-width: 992px) {\n  .feature-row {\n    flex-direction: column;\n  }\n  \n  .feature-showcase.reverse .feature-row {\n    flex-direction: column;\n  }\n  \n  .feature-content, .feature-image {\n    max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
